module.exports = __webpack_public_path__ + "media/assets/images/logos/logo_cba-a556c4e5ee046b398a548b775a4bc657.png";